import type { PostureStatus } from "@studystraight/shared-types";

export interface PostureGaugeProps {
  score: number;
  status: PostureStatus;
  statusLabel: string;
  /**
   * Không thấy trẻ trong khung hình: hiển thị "—" thay vì con số.
   *
   * Bắt buộc phải phân biệt, vì `PostureMonitor` trả **100 điểm** khi chưa đo được gì (đó là
   * "chưa đo", không phải "hoàn hảo"). Vẽ 100 điểm lúc trẻ không có ở bàn là nói sai với người dùng.
   */
  unknown: boolean;
}

const STATUS_CLASS: Record<PostureStatus, string> = {
  GOOD: "gauge--good",
  NEEDS_ADJUSTMENT: "gauge--warn",
  BAD: "gauge--bad",
};

/**
 * §24 — điểm số lớn ở giữa màn hình.
 *
 * Vòng tròn tiến độ vẽ bằng `conic-gradient` chứ không phải SVG: nó là một thuộc tính CSS đổi
 * theo biến, nên cập nhật 4 lần/giây không tạo thêm node nào trong DOM.
 */
export function PostureGauge({
  score,
  status,
  statusLabel,
  unknown,
}: PostureGaugeProps): React.JSX.Element {
  const percent = unknown ? 0 : Math.max(0, Math.min(100, Math.round(score)));

  return (
    <div className={`gauge ${unknown ? "gauge--unknown" : STATUS_CLASS[status]}`}>
      <div
        className="gauge__ring"
        style={{ "--gauge-percent": `${percent}%` } as React.CSSProperties}
        role="img"
        aria-label={unknown ? "Chưa đo được tư thế" : `Điểm tư thế ${percent} trên 100`}
      >
        <span className="gauge__score">{unknown ? "—" : percent}</span>
      </div>
      <strong className="gauge__label">{statusLabel}</strong>
    </div>
  );
}
